import React from "react";
import { Container, Navbar, Nav } from "react-bootstrap";
import "./Navbar.css";
import { navLinks } from "./data/navLinks";
import { HOME } from "../../routes/index.routes";
import authService from "../../services/auth.service";
import { useExternalMedia } from "../../hooks/useExternalMedia";








const logoStyles = {
  maxWidth: "150px",
};

const navBarStyles = {
  backgroundColor: "transparent",
  display: "flex",
  justifyContent: "center",
};



export default function Navigation() {
  const { eraconnecktLogo } = useExternalMedia();
  const logout = authService.logout;
  const isAuthenticated = authService.isAuthenticated();








  return (
    <>

      <Navbar
        collapseOnSelect
        expand="lg"
        style={navBarStyles}
        variant="light"
        className={`navbar-styles dark-navbar`}
      >
        <Container>
          <Navbar.Brand href={HOME}>
            <img
              src={eraconnecktLogo}
              style={logoStyles}
              alt="Eraconneckt logo"
            />
          </Navbar.Brand>
          <Navbar.Toggle
            className="toggler-styles"
            aria-controls="responsive-navbar-nav"
          />

          <Navbar.Collapse
            className="justify-content-end"
            id="responsive-navbar-nav"
          >
            <Nav className="navbar-nav navbar-right">
              {navLinks.map((link, index) => {
                return (
                  <Nav.Link
                    className="nav-links-styles"
                    onClick={() => link?.function()}
                    to={link?.url}
                    href={link?.url}
                    key={`${link?.id}${link?.name}${index}`}
                  >
                    {link?.name}
                  </Nav.Link>
                );
              })}

              {isAuthenticated && (
                <Nav.Link
                  className="nav-links-styles"
                  onClick={logout}
                  style={{
                    color: "#dc3545",
                  }}
                  href={"#logout"}
                >
                  LOG OUT
                </Nav.Link>
              )}
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </>
  );
}
